import request from '../utils/Request';
// import { Methods } from '../config';

const baseURL = 'joker';

const jokerService = {
  getGroups: (type) => {
    return request({
      resource: `${baseURL}/groups/${encodeURIComponent(type)}`,
    });
  },

  getLineFields: (type) => {
    return request({
      resource: `${baseURL}/lineFields/${encodeURIComponent(type)}`,
    });
  },

  getFields: (type) => {
    return request({
      resource: `${baseURL}/fields/${encodeURIComponent(type)}`,
    });
  },
};

export default jokerService;
